import React from 'react';

/**
 * AuthHeader - Shared header block for all auth pages (Glass Cockpit Part B).
 * 56px shield logo + "FLIGHT SIM ACADEMY" (Barlow Condensed 700, tracking 0.14em)
 * + amber "FENIX A320 EDITION" badge.
 */
export const AuthHeader = (props) => {
  return (
    <div className="text-center mb-8" data-testid="auth-header">
      <img
        src="/fsa_shield.png"
        alt="Flight Sim Academy"
        loading="eager"
        className="w-[88px] h-[88px] mx-auto mb-3 object-contain"
      />
      <div className="font-barlow-condensed font-bold text-xl tracking-[0.14em]" style={{ color: 'var(--gc-text-main)' }}>
        FLIGHT SIM ACADEMY
      </div>
      <span
        className="inline-flex items-center font-plex-mono text-[11px] mt-2.5 border rounded-gc-badge px-2 py-1"
        style={{ color: 'var(--gc-amber)', borderColor: 'var(--gc-amber-badge-border)' }}
      >
        FENIX A320 EDITION
      </span>
      {(props.title || props.subtitle) && (
        <div className="mt-5">
          {props.title && (
            <h1 className="font-barlow-condensed font-bold text-2xl" style={{ color: 'var(--gc-text-main)' }}>
              {props.title}
            </h1>
          )}
          {props.subtitle && (
            <p className="text-sm mt-1" style={{ color: 'var(--gc-text-muted)' }}>
              {props.subtitle}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default AuthHeader;
